import { HrefOptions, RawParams, StateOrName, StateParams, StateService, TargetState, Transition, TransitionOptions, TransitionService } from "@uirouter/angularjs";
import { Subject } from "rxjs";

export class Ng1StateProxy {
  public static $inject = ["$state", "$transitions"];
  public stateChange$: Subject<Transition> = new Subject();

  constructor(private $state: StateService, private $transitions: TransitionService) {
    this.$transitions.onSuccess({}, (transition: Transition) => {
      this.stateChange$.next(transition);
    });
  }

  public go(to: StateOrName, params?: RawParams, options?: TransitionOptions): void {
    // Here it will be good if we return a promise to be able to catch if the redirection wasn't successful.
    // This way if we click on item we can change the menu state only if the state transition was successful and on error to show some message.
    this.$state.go(to, params, options);
  }

  public href(to: StateOrName, params?: RawParams, options?: HrefOptions): string {
    return this.$state.href(to, params, options);
  }

  public target(to: StateOrName, params?: RawParams, options?: TransitionOptions): TargetState {
    return this.$state.target(to, params, options);
  }

  public getCurrentState(): string {
    return this.$state.current.name;
  }

  public getParam(key: string): string | null {
    if (!this.$state.params[key]) {
      return null;
    }
    if (typeof this.$state.params[key] !== "string") {
      return null;
    }
    return this.$state.params[key];
  }

  public getParams(): StateParams {
    return this.$state.params;
  }
}
